import { AuthType, AuthTypeEnum, BaseAuthenticationMethod } from './base-authentication-method';

export class Idin extends BaseAuthenticationMethod {
    type = 'idin';
    authtype: AuthType = AuthTypeEnum.AFTERVIEW;
    initials?: string;
    automaticValidation?: boolean;
    legalLastnamePrefix?: string;
    legalLastname?: string;
    dateofbirth?: Date;
    houseno?: number;
    housenosuf?: string;
    postalcode?: string;
    city?: string;
    phoneNumber?: string;
    email?: string;
}
